import script from "./VLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./VLoader.vue?vue&type=script&lang=ts&setup=true"

import "./VLoader.vue?vue&type=style&index=0&id=8a9222f8&lang=postcss"

const __exports__ = script;

export default __exports__